import { DialogContent, Input, Select, SelectChangeEvent, useFlashMessage } from '@indigo-ag/component-module';
import i18next from 'core/i18n';
import React, { useEffect, useState } from 'react';

import { Credit } from '@indigo-ag/schema';

import { EnhancedDialog, ModalActionButtons } from 'shared';
import { ScoreSectionProps } from '../../ScoreSection';

export interface ScoreModalProps extends ScoreSectionProps {
  closeModal: () => void;
  open: boolean;
  // TODO create type for function
  updateCredit: (newCreditInfo: Partial<Credit>) => Promise<unknown>;
}

export const ScoreModal: React.FunctionComponent<ScoreModalProps> = ({
  closeModal,
  open,
  scoreSectionInfo,
  updateCredit
}) => {
  /**
   * State
   */
  const [scoreType, setScoreType] = useState(scoreSectionInfo?.scoreType || null);
  const [scoreNumber, setScoreNumber] = useState(scoreSectionInfo?.scoreNumber || 0);

  const getDefaultState = (): void => {
    setScoreType(scoreSectionInfo?.scoreType || '');
    setScoreNumber(scoreSectionInfo?.scoreNumber || 0);
  };

  useEffect(() => {
    getDefaultState();
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const { addFlashMessage } = useFlashMessage();

  const updateInfo = () => {
    return updateCredit({
      scoreType: scoreType || undefined,
      scoreNumber
    }).then(() => {
      addFlashMessage({
        content: `${i18next.t('scoreConsulting')} ${i18next.t('hasBeenUpdatedSuccessfully')}`,
        title: '',
        variant: 'success'
      });
    });
  };

  const updateScoreType = (event: SelectChangeEvent<string>): void => {
    setScoreType(event.target.value);
  };

  const handleNumberScore = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setScoreNumber(parseFloat(event.target.value));
  };

  return (
    <EnhancedDialog open={open} onClose={closeModal} title={i18next.t('scoreConsulting')}>
      <DialogContent>
        <Select
          label={i18next.t('scoring')}
          name="scoreType"
          value={scoreType}
          options={['A+', 'A-', 'B', 'C', 'D'].map(v => ({ name: v, value: v }))}
          onChange={updateScoreType}
        />
        <Input label={i18next.t('number')} value={scoreNumber || ''} variant="number" onChange={handleNumberScore} />
      </DialogContent>

      <ModalActionButtons
        changeButtonName={i18next.t('saveChanges')}
        closeModal={closeModal}
        disabled={!scoreType || !scoreNumber}
        save={updateInfo}
      />
    </EnhancedDialog>
  );
};
